import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { GetOrder$Params } from 'src/api/generated/fn/order-v-2/get-order';
import { BillDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Bills/bill-dto';
import { MenuCurrencyDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Menu/menu-currency-dto';
import { OrderDetailsDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/OrderV2/order-details-dto';
import { OrderV2Service } from 'src/api/generated/services';
import { CurrencyService } from 'src/app/pos-panel/services/currency-helper/currency.service';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit, OnDestroy {

  order: OrderDetailsDto;
  orderId: string;
  venueId: string;
  bills: Array<BillDto> = new Array<BillDto>();
  selectedBill: BillDto;
  orderTables: string;
  venueIdUpdateSubscription: Subscription;
  currency: MenuCurrencyDto;

  constructor(private route: ActivatedRoute,
              public router: Router,
              public currentVenueHelper: CurrentVenueHelperService,
              public currencyService: CurrencyService,
              public orderService: OrderV2Service) {

      this.route.params.subscribe(params => {
      this.venueId = params['venue-id'];
      this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
      this.orderId = params['order-id'];
      const getParams: GetOrder$Params = { orderId: this.orderId };
      this.orderService.getOrder(getParams).subscribe( response => {
        this.order = response;
        this.orderTables =  this.order.tables ? this.order.tables?.map(table => table.name).join(", ") : "";
      } );
  });  
  this.currencyService.currencyObservable().subscribe(currency => this.currency = currency);

}


  ngOnInit(): void {
  }

  goToBill(order: any){
    this.router.navigate([this.venueId, 'turnover', 'bills', order.id]);
  }

  goToTurnoverRecords(){
    this.router.navigate([this.venueId, 'turnover'], { queryParams: { activeIndex: 0 }});
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
